import { useMemo } from 'react';

import Image from './Image';
import Typography from './Typography';
import * as S from './styled/ListProfileImage.styled';

/**
 * @author @buunsal
 */
const colors = [
	{
		background: '#FAF7EF',
		color: '#EBBC3F'
	},
	{
		background: '#EFFAF3',
		color: '#32BD6D'
	},
	{
		background: '#FAEFEF',
		color: '#C42222'
	},
	{
		background: '#FAF9EF',
		color: '#CBBD34'
	},
	{
		background: '#F3EFFA',
		color: '#824BE2'
	}
];

const ListProfileImage = ({ data }) => {
	const activeColor = useMemo(() => (data?.online === 'active' ? 'var(--green)' : 'var(--red)'), [data]);
	const randomColorIndex = useMemo(() => {
		const array = new Uint32Array(1);
		window.crypto.getRandomValues(array);
		return array[0] % colors.length;
	}, []);

	return (
		<S.Container>
			<S.ImageContainer>
				{data?.avatarPath ? (
					<Image url={data?.avatarPath} height="4rem" width="4rem" style={{ borderRadius: '50%' }} />
				) : (
					<S.ImagePlaceholder
						style={{
							backgroundColor: colors[randomColorIndex].background,
							color: colors[randomColorIndex].color
						}}>
						<Typography
							variant="p2"
							fontWeight="500"
							style={{
								backgroundColor: colors[randomColorIndex].background,
								color: colors[randomColorIndex].color
							}}>
							{data?.fullName
								?.split(' ')
								.map((val, index, values) => (index === 0 || index + 1 === values.length ? val[0] : ''))
								.join('')}
						</Typography>
					</S.ImagePlaceholder>
				)}
				{!data.activeDisabled && <S.Icon style={{ backgroundColor: activeColor }} />}
			</S.ImageContainer>

			<Typography>{data?.fullName}</Typography>
		</S.Container>
	);
};

export default ListProfileImage;
